function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import pathOr from 'ramda/src/pathOr';
import { stateGo } from 'redux-ui-router';
import i18n from 'invision-core/src/components/i18n/i18n';
import { hasAccess } from 'invision-core/src/components/security/permission.service';
import { MetadataCodeLoadedSelector, MetadataOptionsForCodeValuesSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { UserSecurityAttributesSelector } from 'invision-core/src/components/session/session.selectors';
import CustomerLocaleKeys from '../../../../../../locales/keys';
import { CanUserPerformFinanceAdjustmentSelector, CurrentCustomerIdSelector } from '../../../../../../reducers/selectors/customer.selectors';
import { CanReturnDeviceSelector } from '../../../../../../reducers/selectors/apply.credit.modal.selectors';
import { DeviceFinancingNameSelector, IsFetchingDeviceReturnDetailsSelector, SubscriberDeviceReturnDetailsSelector } from '../../../../../../reducers/selectors/customer.devices.selectors';
import { createDeviceAdjustment, retrieveDeviceRefundAmount } from '../../../../../../reducers/actions/customer.devices.actions';
import { DEPOSIT_ADJUSTMENT } from '../../../../../adjustment/adjustment.modal.constants';
import { DOWN_PAYMENT_TYPE } from '../../../../../../customercare.constants';
import { MAKE_PAYMENT_ROUTE } from '../../../../makePayment/make.payment.constants';
import { ONE_TIME_MAKE_PAYMENT } from '../../../../../../security.attributes';
import { INVENTORY_DETAILS_STATE_REDIRECT } from '../../../../../../reactRoutes';
var DeviceFinanceDetailsController = /*#__PURE__*/function () {
  function DeviceFinanceDetailsController($ngRedux, $timeout, uiNotificationService) {
    _classCallCheck(this, DeviceFinanceDetailsController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $timeout: $timeout,
      CustomerLocaleKeys: CustomerLocaleKeys,
      DEPOSIT_ADJUSTMENT: DEPOSIT_ADJUSTMENT,
      DOWN_PAYMENT_TYPE: DOWN_PAYMENT_TYPE,
      thumbnailHeight: 95,
      thumbnailWidth: 65,
      uiNotificationService: uiNotificationService,
      onCloseAdjustmentModal: this.onCloseAdjustmentModal.bind(this),
      onSubmitAdjustmentModal: this.onSubmitAdjustmentModal.bind(this),
      onCloseReturnDeviceModal: this.onCloseReturnDeviceModal.bind(this),
      onSubmitReturnDeviceModal: this.onSubmitReturnDeviceModal.bind(this)
    });
  }
  return _createClass(DeviceFinanceDetailsController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var controllerActions = {
        createDeviceAdjustment: createDeviceAdjustment,
        retrieveDeviceRefundAmount: retrieveDeviceRefundAmount,
        stateGo: stateGo
      };
      var mapStateToProps = function mapStateToProps(store) {
        return {
          adjustmentReasonsLoaded: MetadataCodeLoadedSelector(CODES.BalanceAdjustmentReason, store),
          adjustmentReasonOptions: MetadataOptionsForCodeValuesSelector(CODES.BalanceAdjustmentReason, store),
          canReturnDevice: CanReturnDeviceSelector(store),
          canUserPerformFinanceAdjustment: CanUserPerformFinanceAdjustmentSelector(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          deviceFinancingName: DeviceFinancingNameSelector(store),
          deviceReturnDetails: SubscriberDeviceReturnDetailsSelector(store),
          isFetchingDeviceReturnDetails: IsFetchingDeviceReturnDetailsSelector(store),
          userSecurityAttributes: UserSecurityAttributesSelector(store)
        };
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToProps, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.adjustmentModalConfig = {
        onRegisterApi: function onRegisterApi(_ref) {
          var api = _ref.api;
          _this.adjustmentModalApi = api;
        }
      };
      this.returnDeviceModalConfig = {
        onRegisterApi: function onRegisterApi(_ref2) {
          var api = _ref2.api;
          _this.returnDeviceModalConfigApi = api;
        }
      };
      if (this.deviceFinanceDetails) {
        this.moreMenuItems = this.getMoreMenuItems();
        this.deviceAttributes = this.getAttributes();
      }
      this.discountToolTip = require('../../../../../shared/tooltipTemplates/discount.tooltip.html');
    }
  }, {
    key: "getAttributes",
    value: function getAttributes() {
      var inventoryIdentifierValue = pathOr(null, ['SubscriberInventory', 'InventoryIdentifierValue'], this.deviceFinanceDetails);
      return pathOr([], ['SubscriberInventory', 'Attributes'], this.deviceFinanceDetails).reduce(function (attrs, attribute) {
        attrs.push(attribute.Value);
        return attrs;
      }, inventoryIdentifierValue ? [inventoryIdentifierValue] : []);
    }
  }, {
    key: "getMoreMenuItems",
    value: function getMoreMenuItems() {
      var _this2 = this;
      var moreMenuItems = [{
        id: this.CustomerLocaleKeys.VIEW_DETAILS,
        title: i18n.translate(this.CustomerLocaleKeys.VIEW_DETAILS),
        action: function action() {
          _this2.actions.stateGo(INVENTORY_DETAILS_STATE_REDIRECT, {
            customerId: _this2.state.currentCustomerId,
            inventoryId: pathOr(null, ['SubscriberInventory', 'Id'], _this2.deviceFinanceDetails)
          });
        }
      }];
      if (this.deviceFinanceDetails.DeviceFinanceAccountNumber && this.state.canUserPerformFinanceAdjustment) {
        moreMenuItems.push({
          id: this.CustomerLocaleKeys.ADJUSTMENTS.APPLY_ADJUSTMENT,
          title: i18n.translate(this.CustomerLocaleKeys.ADJUSTMENTS.APPLY_ADJUSTMENT),
          action: function action() {
            _this2.showAdjustmentModal = true;
            _this2.$timeout(function () {
              _this2.adjustmentModalApi.open();
            });
          }
        });
      }
      if (hasAccess(this.state.userSecurityAttributes, ONE_TIME_MAKE_PAYMENT)) {
        moreMenuItems.push({
          id: this.CustomerLocaleKeys.MAKE_A_PAYMENT,
          title: i18n.translate(this.CustomerLocaleKeys.MAKE_A_PAYMENT),
          action: function action() {
            _this2.actions.stateGo(MAKE_PAYMENT_ROUTE, {
              account: _this2.deviceFinanceDetails.DeviceFinanceAccountNumber
            });
          }
        });
      }
      if (this.state.canReturnDevice) {
        moreMenuItems.push({
          id: this.CustomerLocaleKeys.INVENTORY.RETURN_DEVICE,
          title: i18n.translate(this.CustomerLocaleKeys.INVENTORY.RETURN_DEVICE),
          action: function action() {
            _this2.actions.retrieveDeviceRefundAmount(_this2.deviceFinanceDetails.SubscriberInventory && _this2.deviceFinanceDetails.SubscriberInventory.SubscriberProductId, _this2.state.currentCustomerId).then(function () {
              _this2.showReturnDeviceModal = true;
              _this2.$timeout(function () {
                _this2.returnDeviceModalConfigApi.open();
              });
            }).catch(function (error) {
              _this2.uiNotificationService.transientError(error.translatedMessage);
            });
          }
        });
      }
      return moreMenuItems;
    }
  }, {
    key: "onMoreMenuItemSelected",
    value: function onMoreMenuItemSelected(_ref3) {
      var itemProps = _ref3.item;
      itemProps.action(itemProps);
    }
  }, {
    key: "onCloseAdjustmentModal",
    value: function onCloseAdjustmentModal() {
      this.adjustmentModalApi.close();
      this.showAdjustmentModal = false;
    }
  }, {
    key: "onSubmitAdjustmentModal",
    value: function onSubmitAdjustmentModal() {
      this.refreshServiceDetails && this.refreshServiceDetails();
      this.refreshConvergentBillerDetails && this.refreshConvergentBillerDetails();
      this.onCloseAdjustmentModal();
    }
  }, {
    key: "onCloseReturnDeviceModal",
    value: function onCloseReturnDeviceModal() {
      this.showReturnDeviceModal = false;
      this.returnDeviceModalConfigApi.close();
    }
  }, {
    key: "onSubmitReturnDeviceModal",
    value: function onSubmitReturnDeviceModal(deviceDetails) {
      var _this3 = this;
      this.actions.createDeviceAdjustment(deviceDetails, this.state.currentCustomerId).then(function () {
        _this3.uiNotificationService.success(i18n.translate(_this3.CustomerLocaleKeys.CUSTOMER_DASHBOARD.DEVICE_RETURN_SUCCESS));
        _this3.refreshServiceDetails && _this3.refreshServiceDetails();
        _this3.refreshConvergentBillerDetails && _this3.refreshConvergentBillerDetails();
      }).catch(function (error) {
        _this3.uiNotificationService.transientError(error.translatedMessage);
      }).finally(function () {
        _this3.onCloseReturnDeviceModal();
      });
    }
  }, {
    key: "getDeviceFinancingMarketingNameForHeading",
    value: function getDeviceFinancingMarketingNameForHeading() {
      return i18n.translate(this.CustomerLocaleKeys.CUSTOMER_DASHBOARD.DEVICE_FINANCING_FOR, {
        deviceFinancingName: this.state.deviceFinancingName
      });
    }
  }, {
    key: "discountTooltipText",
    value: function discountTooltipText() {
      if (this.deviceFinanceDiscounts.length > 0) {
        return "".concat(this.deviceFinanceDiscounts.length, " ").concat(i18n.translate(this.deviceFinanceDiscounts.length === 1 ? CustomerLocaleKeys.DISCOUNT : CustomerLocaleKeys.DISCOUNTS_LABEL));
      }
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }]);
}();
export default {
  bindings: {
    currencyCode: '<',
    deviceFinanceDetails: '<',
    deviceFinanceDiscounts: '<',
    refreshServiceDetails: '&?',
    refreshConvergentBillerDetails: '&?'
  },
  template: require('./device.financing.html'),
  controller: DeviceFinanceDetailsController
};